import {OrderBy} from './OrderBy';

export class BasicScenario {
allowNullReturn: boolean | null;
languageCode: string;
orderBy: OrderBy[];
}

